export default "__VITE_ASSET__BejQy_1t__"